import { useTranslation } from 'react-i18next'
import DateRangeFilter from '../../../components/ui/DateRangeFilter'
import FilterBar from '../../../components/ui/FilterBar'
import type { NotificationStatusFilter } from '../types'

/**
 * Bildirimler sayfasının filtre çubuğu (spec FR-028 / FR-029).
 *
 * Durum sekmeleri paylaşılan {@link FilterBar}'ın `tabs` yuvasını, tarih aralığı ise `children`
 * yuvasını kullanır (Reuse Mandate — ekrana özel filtre çubuğu yazılmaz). Arama kutusu **yoktur**:
 * kullanıcı isteğinde serbest metin araması yer almıyor (spec Assumptions).
 */
export interface NotificationFiltersProps {
  status: NotificationStatusFilter
  onStatus: (status: NotificationStatusFilter) => void
  from: string | null
  to: string | null
  onRange: (range: { from: string | null; to: string | null }) => void
  /** Herhangi bir filtre etkinse "Temizle" gösterilir. */
  showClear: boolean
  onClear: () => void
}

/** `FilterBar.tabs` sayısal/`null` kimlik bekler; durum enum'ını sekme kimliğine eşleriz. */
const TAB_TO_STATUS: Record<number, NotificationStatusFilter> = {
  0: 'ALL',
  1: 'UNREAD',
  2: 'READ',
}
const STATUS_TO_TAB: Record<NotificationStatusFilter, number> = {
  ALL: 0,
  UNREAD: 1,
  READ: 2,
}

export default function NotificationFilters({
  status,
  onStatus,
  from,
  to,
  onRange,
  showClear,
  onClear,
}: Readonly<NotificationFiltersProps>) {
  const { t } = useTranslation()

  return (
    <FilterBar
      tabs={[
        { id: 0, label: t('notifications.filter.all') },
        { id: 1, label: t('notifications.filter.unread') },
        { id: 2, label: t('notifications.filter.read') },
      ]}
      activeTabId={STATUS_TO_TAB[status]}
      onTab={(id) => onStatus(TAB_TO_STATUS[id ?? 0] ?? 'ALL')}
      showClear={showClear}
      clearLabel={t('activity.list.filters.clear')}
      onClear={onClear}
    >
      <DateRangeFilter
        from={from}
        to={to}
        onChange={onRange}
        fromLabel={t('notifications.filter.dateFrom')}
        toLabel={t('notifications.filter.dateTo')}
      />
    </FilterBar>
  )
}
